"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PaginationDots = _ref => {
  let _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    _ref$activeIndex = _ref.activeIndex,
    activeIndex = _ref$activeIndex === void 0 ? 0 : _ref$activeIndex,
    onChange = _ref.onChange;
  if (count <= 1) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex justify-center gap-2 mt-2",
    children: Array.from({
      length: count
    }).map((_, idx) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      onClick: () => onChange === null || onChange === void 0 ? void 0 : onChange(idx),
      className: "w-2 h-2 rounded-full cursor-pointer transition-all\n            ".concat(idx === activeIndex ? 'bg-purple-600' : 'bg-gray-300')
    }, idx))
  });
};
var _default = exports.default = PaginationDots;